import { getTaskInputSchema, getTaskOutputSchema } from "./output.mjs";
import { oc } from "@orpc/contract";
//#region src/api/orpc/task/getById.ts
const getByIdRoute = oc.route({
	summary: "Get a task by ID",
	description: "Returns the status and basic outputs of a task owned by the current user. Heavy fields (parameters, ...) are opt-in via with_<field>=true query params.",
	method: "GET",
	path: "/{id}"
}).input(getTaskInputSchema).output(getTaskOutputSchema).errors({
	NOT_FOUND: {
		status: 404,
		message: "Task not found"
	},
	UNAUTHORIZED: {
		status: 401,
		message: "Authentication required"
	}
});
//#endregion
export { getByIdRoute };
